export default __webpack_public_path__ + "static/media/MightyMagnets_01.177d9bae.png";